/**
 * Interval polling helper for REST UI refresh.
 */

const DEFAULT_MS = 15000;

/**
 * @param {() => void} onTick
 * @param {number} [intervalMs]
 * @returns {() => void} clear
 */
export function startPolling(onTick, intervalMs = DEFAULT_MS) {
  const id = setInterval(onTick, intervalMs);
  return () => clearInterval(id);
}
